/**
 * @file 服务商选择
 * @author gaoxunchen
 */

import _ from 'lodash';
import React from 'react';
import { Select } from '@tencent/spaui';
import classnames from 'classnames';

import { formatAgencyList } from '@/pages/agency/utils/format';

import { GranularityType, AgencyType } from '../../constants';

import './index.scoped.less';

interface AgencySelectProps {
  /* 数据 */
  type: AgencyType;
  /* 数据 */
  data: Record<string, any>[];
  /* 值 */
  value: number[];
  /* 设置值 */
  setValue: (value: number[]) => void;
  /* 粒度 */
  granularityType?: GranularityType;
}

const AgencyTypeNameMap = {
  [AgencyType.parent]: '服务商账号',
  [AgencyType.child]: '子账号',
};

const AgencySelect: React.FC<AgencySelectProps> = (props) => {
  const { type, data, value, setValue, granularityType = GranularityType.day } = props;

  const renderItem = (item: Record<string, any>) => {
    const { agency_uid, spid, remark, ad_platform_type, color } = item;
    const active = value.includes(agency_uid);
    const disabled = granularityType === GranularityType.hour && ad_platform_type === 2;

    return (
      <div
        className={classnames('agency-select-item', { active, disabled })}
        onClick={() => {
          if (active) {
            return setValue(_.without(value, agency_uid));
          }
          return setValue([...value, agency_uid]);
        }}
      >
        <div className="label">
          <span className="dot" style={{ ...(color ? { background: color } : {}) }}></span>
          {ad_platform_type === 2 ? spid : `UID:${agency_uid}`}
        </div>
        <div className="value">{remark || agency_uid}</div>
      </div>
    );
  };

  return (
    <div className="agency-select">
      <div className="agency-select-label">{AgencyTypeNameMap[type] || type}</div>
      <div className="agency-select-content">
        {type === AgencyType.child ? (
          <Select
            multiple
            checkAll
            data={formatAgencyList(data)}
            value={value}
            onChange={(_event: any, value: number[]) => setValue(value)}
          />
        ) : null}
        <div className="agency-select-group">
          {
            data
              .filter((v) => {
                if (type === AgencyType.child) {
                  return value.includes(v.agency_uid);
                }
                return v;
              })
              .map((v) => renderItem(v))
          }
        </div>
      </div>
    </div>
  );
};

export default AgencySelect;
